import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";
import io from "socket.io-client";

import * as apiCaller from "../../api/apiCaller";
import * as cookies from "../../ultis/cookies";

export const GET_CONVERSATION_HISTORY = "GET_CONVERSATION_HISTORY";
export const GET_CONVERSATION_HISTORY_ERROR = "GET_CONVERSATION_HISTORY_ERROR";
export const GET_CONVERSATION_HISTORY_SUCCESS =
  "GET_CONVERSATION_HISTORY_SUCCESS";

export const GET_LIST_CONVERSATION = "GET_LIST_CONVERSATION";
export const GET_LIST_CONVERSATION_ERROR = "GET_LIST_CONVERSATION_ERROR";
export const GET_LIST_CONVERSATION_SUCCESS = "GET_LIST_CONVERSATION_SUCCESS";

export const CLOSE_CONVERSATION = "CLOSE_CONVERSATION";
export const CLOSE_CONVERSATION_ERROR = "CLOSE_CONVERSATION_ERROR";
export const CLOSE_CONVERSATION_SUCCESS = "CLOSE_CONVERSATION_SUCCESS";

export const JOIN_CONVERSATION = "JOIN_CONVERSATION";
export const JOIN_CONVERSATION_ERROR = "JOIN_CONVERSATION_ERROR";
export const JOIN_CONVERSATION_SUCCESS = "JOIN_CONVERSATION_SUCCESS";

export const SEND_MESSAGE = "SEND_MESSAGE";
export const SEND_MESSAGE_ERROR = "SEND_MESSAGE_ERROR";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  history: [],
  conversation: {},
  conversations: [],
  error: false,
  count: 0,
  loading: false,
  message: {},
  join: {},
};

export const ConversationHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_CONVERSATION_HISTORY:
      return {
        ...state,
      };
    case GET_CONVERSATION_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload,
      };
    case GET_CONVERSATION_HISTORY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_LIST_CONVERSATION:
      return {
        ...state,
      };
    case GET_LIST_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversations: action.payload,
      };
    case GET_LIST_CONVERSATION_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case CLOSE_CONVERSATION:
      return {
        ...state,
        loading: true,
      };
    case CLOSE_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        join: action.payload,
      };
    case CLOSE_CONVERSATION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    case JOIN_CONVERSATION:
      return {
        ...state,
        loading: true,
      };
    case JOIN_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        join: action.payload,
      };
    case JOIN_CONVERSATION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    case SEND_MESSAGE:
      return {
        ...state,
      };
    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        message: action.payload,
      };
    case SEND_MESSAGE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const getListConversationHistory = (conversationId) => ({
  type: GET_CONVERSATION_HISTORY,
  data: {
    conversationId,
  },
});

export const getListConversation = () => ({
  type: GET_LIST_CONVERSATION,
  data: {},
});

export const closeConversation = (id) => ({
  type: CLOSE_CONVERSATION,
  data: {
    id,
  },
});
export const joinConversation = (id) => ({
  type: JOIN_CONVERSATION,
  data: {
    id,
  },
});

export const sendMessage = (conversationId, message) => ({
  type: SEND_MESSAGE,
  data: {
    conversationId,
    message,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListConversationHistory,
      closeConversation,
      joinConversation,
      getListConversation,
      sendMessage,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListConversationHistoryApi = (agentId, conversationId) => {
  return apiCaller.getData("/omni-channel/conversation/conversation-history", {
    agentId: agentId,
    conversationId,
  });
};

const joinConversationApi = (id) => {
  return apiCaller.put(`/omni-channel/conversation/join-conversation/${id}`);
};

const closeConversationApi = (id) => {
  return apiCaller.put(`/omni-channel/conversation/close-conversation/${id}`);
};

const getConversationApi = () => {
  return apiCaller.get(`/omni-channel/conversation`);
};

const sendMessageApi = (conversationId, message) => {
  return apiCaller.post(`omni-channel/conversation/send-message`, {
    conversationId,
    message,
  });
};

/**
 * sagas
 */
function connect() {
  const socket = io("http://omni-ws-dev.api-connect.io/", {
    query: {
      resource: "agent",
      userId: cookies.get("agentId") ? cookies.get("agentId") : "",
      accessToken: cookies.get("access_token")
        ? cookies.get("access_token")
        : "",
    },
    path: "/",
  });

  return new Promise((resolve) => {
    socket.on("connection", () => {
      resolve(socket);
    });
  });
}

export const getListConversationHistoryFlow = function* () {
  while (true) {
    const action = yield take(GET_CONVERSATION_HISTORY);
    const agent = yield select((state) => state?.auth?.init?.agentStatus?.id);
    try {
      const res = yield call(
        getListConversationHistoryApi,
        agent ? agent : "",
        action.data.conversationId
      );

      yield put({ type: GET_CONVERSATION_HISTORY_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_CONVERSATION_HISTORY_ERROR, error });
    }
  }
};

export const joinConversationFlow = function* () {
  while (true) {
    const action = yield take(JOIN_CONVERSATION);
    try {
      const res = yield call(joinConversationApi, action.data.id);
      yield put({ type: JOIN_CONVERSATION_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: JOIN_CONVERSATION_ERROR, error });
    }
  }
};

export const closeConversationFlow = function* () {
  while (true) {
    const action = yield take(CLOSE_CONVERSATION);
    try {
      const res = yield call(closeConversationApi, action.data.id);
      yield put({ type: CLOSE_CONVERSATION_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: CLOSE_CONVERSATION_ERROR, error });
    }
  }
};

export const getConversationFlow = function* () {
  while (true) {
    yield take(GET_LIST_CONVERSATION);
    try {
      const res = yield call(getConversationApi);
      const data = res.data.sort(function (a, b) {
        return Date.parse(b.createdAt) - Date.parse(a.createdAt);
      });
      yield put({ type: GET_LIST_CONVERSATION_SUCCESS, payload: data });
    } catch (error) {
      yield put({ type: GET_LIST_CONVERSATION_ERROR, error });
    }
  }
};

export const sendMessageFlow = function* () {
  while (true) {
    const action = yield take(SEND_MESSAGE);
    try {
      const res = yield call(
        sendMessageApi,
        action.data.conversationId,
        action.data.message
      );
      yield put({ type: SEND_MESSAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: SEND_MESSAGE_ERROR, error });
    }
  }
};
